import styled from 'styled-components';
import Box from '@rsos/components/capstone/base/Box';

export const IconWrapper = styled(Box).attrs({
  color: 'lightDanger',
})`
  opacity: 0.5;
`;
